module.exports = __webpack_public_path__ + "img/Capture.bb51a992.png";